// Require stylesheet
import 'stylesheets/marketing.scss';

// Require all images to be rendered by Rails views
require.context('images', true);

import Rails from '@rails/ujs';
Rails.start();
